import { type Common } from '../common.js';
import {
  type CreateScheduledFlowTrigger,
  type FindAllOptions,
  type ScheduledFlowTrigger,
  type UpdateScheduledFlowTrigger,
} from '../models/flow/scheduledTrigger/config.js';

export class API {
  common: Common;
  baseEndpoint = '/flow/schedules';
  constructor(common: Common) {
    this.common = common;
  }

  async findAll(queryParams: FindAllOptions): Promise<ScheduledFlowTrigger[]> {
    const url = this.common.constructPath(this.baseEndpoint, queryParams);
    const { triggers } = await this.common.getJSON(url);
    return triggers;
  }

  async findOneById(id: string): Promise<ScheduledFlowTrigger> {
    const url = this.common.constructPath(`${this.baseEndpoint}/${id}`);
    const { trigger } = await this.common.getJSON(url);
    return trigger;
  }

  async update(
    id: string,
    updateValues: UpdateScheduledFlowTrigger
  ): Promise<ScheduledFlowTrigger> {
    const url = this.common.constructPath(`${this.baseEndpoint}/${id}`);
    const { trigger } = await this.common.patchJSON(url, updateValues);
    return trigger;
  }

  async create(createValues: CreateScheduledFlowTrigger): Promise<ScheduledFlowTrigger> {
    const url = this.common.constructPath(this.baseEndpoint);
    const { trigger } = await this.common.postJSON(url, createValues, 'POST');
    return trigger;
  }

  async delete(id: string): Promise<boolean> {
    const url = this.common.constructPath(`${this.baseEndpoint}/${id}`);
    const result = await this.common.deleteJSON(url);
    return result?.success ?? true;
  }

  async pause(id: string, note?: string): Promise<boolean> {
    const url = this.common.constructPath(`${this.baseEndpoint}/${id}/pause`);
    const { success } = await this.common.postJSON(url, { note }, 'POST');
    return success;
  }

  async unpause(id: string, note?: string): Promise<boolean> {
    const url = this.common.constructPath(`${this.baseEndpoint}/${id}/unpause`);
    const { success } = await this.common.postJSON(url, { note }, 'POST');
    return success;
  }

  async trigger(id: string, overlapPolicy?: string): Promise<boolean> {
    const url = this.common.constructPath(`${this.baseEndpoint}/${id}/trigger`);
    const { success } = await this.common.postJSON(url, { overlapPolicy }, 'POST');
    return success;
  }
}
